<template>
    <div class="pb-3"
        :style="!isMobilePort ? 'margin-right: 115px;' : ''">
        <component :is="isLink ? 'a' : 'div'" :href="isLink ? link : null"
            @click="isLink ? registerClick() : null" target="_blank">
            <h4 class="d-inline" :class="isLink ? 'primary--text' : ''">{{ title }}</h4>
        </component>
        <div class="d-inline content-section-tags">
            <v-tooltip
                v-if="insightsCount"
                color="black"
                open-delay="750"
                bottom
                >
                <template #activator="{ on }">
                    <v-chip
                        tabindex="0"
                        @keydown.enter="openInsights"
                        x-small
                        class="pa-1 font-weight-bold"
                        v-on="on"
                        @click="openInsights"
                        color="accent2Light"
                        label
                        style="cursor: pointer;"
                    >
                    <span>INSIGHTS ({{ insightsCount }})</span>
                    </v-chip>
                </template>
                <span class="tooltip-content">Jump to Insights</span>
            </v-tooltip>
        </div>
    </div>
</template>

<script>
import ContentSectionTags from './ContentSectionTags.vue';
import Mobile from '../inc/mixins/mobile';
export default {
    data: function() {
        return {

        }
    },
    components: {ContentSectionTags},
    mixins:[Mobile],
    props: {
        title: {
            type: String,
            required: true
        },
        contentId: {
            type: Number,
            required: true
        },
        isLink: {
            type: Boolean,
            required: true
        },
        insightsCount: {
            type: Number,
            required: false,
        }
    },
    computed: {
        link() {
            return Routing.generate('content_id_redirect', {
                'contentId': this.contentId
            });
        }
    },
    methods:{
        registerClick(){
            console.log('Log details');
        },
        openInsights() {
            this.$emit('openInsights');
        }
    }
}
</script>

<style scoped lang="scss">

</style>